module.exports = __webpack_public_path__ + "img/logo.0bfeb6a2.svg";